import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';
import { avatar as avatarColours } from '../../constants/ColourConstants';
import { DateStyles } from '../../constants/CentricConstants';
import { FormattedDate } from 'react-intl';
import Avatar from 'material-ui/Avatar';
import SchoolIcon from 'material-ui/svg-icons/social/school';

const style = {
    listItem: {
        padding: '2px',
    },
};

function getDisplayDuration(duration) {
    let displayDuration = '';
    if (duration > 0) {
        var hours = Math.floor( duration / 60);
        var minutes = duration % 60;

        if (hours > 0) {
            displayDuration = hours + 'h';
            if (minutes > 0) {
                displayDuration += ' ' + minutes + 'm';
            }
        } else if (minutes > 0) {
            displayDuration = minutes + 'm';
        }
    }
    return displayDuration;
}

class CourseComplianceItem extends Component {

    render() {
        const infoLink     = `/dashboard/course/${this.props.data.id}`;
        let listItemProps = {
            key: this.props.data.id,
            style: style.listItem,
            primaryText: <Link to={infoLink} className="primaryText">{this.props.data.name}</Link>
        };

        let avatarProps = {
            icon:   <SchoolIcon />,
            style:  avatarColours.default
        };
        let completedLine;
        let expiryLine;


        if (!!this.props.data.skillId) {
            // skill takes over enrolmentStatus
            if (!!this.props.data.skillAcquired) {
                let acquired = new Date(this.props.data.skillAcquired);
                completedLine = (<span>Completed on <FormattedDate {...DateStyles.full} value={acquired} /> | Score: {this.props.data.skillScore}</span>);
            } else {
                completedLine = (<span>Not completed yet</span>);
            }
            if (!!this.props.data.skillExpiry) {
                let expiry = new Date(this.props.data.skillExpiry);
                let now = new Date();
                let verb = 'Expires';
                if (expiry < now) {
                    avatarProps.style = (!!this.props.data.enrolmentRequirement ? avatarColours.required : avatarColours.expired);
                    verb = 'Expired';
                } else if (expiry < now.setMonth(now.getMonth() + 1)) {
                    avatarProps.style = avatarColours.expiring;
                } else {
                    avatarProps.style = avatarColours.completed;
                }
                expiryLine = (<span>{verb} on <FormattedDate {...DateStyles.full} value={expiry}/></span>);
            } else {
                avatarProps.style = (!!!!this.props.data.skillAcquired ? avatarColours.completed : avatarColours.required);
            }
        }

        listItemProps.leftAvatar = (<Link to={infoLink}><Avatar {...avatarProps} /></Link>);
        listItemProps.secondaryText = (
            <Link to={infoLink} className="secondaryText">
                {completedLine}<br /><em>{expiryLine}</em>
            </Link>
        );
        listItemProps.secondaryTextLines = 2;
        return (
            <ListItem {...listItemProps} />
        );
    }
}

CourseComplianceItem.propTypes = {
    data:   PropTypes.shape({
        id:             PropTypes.number.isRequired,
        name:           PropTypes.string.isRequired,
        duration:       PropTypes.string,
        skillExpiry:    PropTypes.object, // Date
        skillAcquired:  PropTypes.object, // date
        enrolmentRequirement: PropTypes.bool
    })
};



export default CourseComplianceItem;
